export const KEYBOARD_SHORTCUT_PLATFORMS = Object.freeze({
  WINDOWS_LINUX: 'windows_linux',
  MAC: 'mac',
});

export const detectKeyboardShortcutPlatform = platform => {
  const browserPlatform =
    typeof navigator === 'undefined'
      ? ''
      : (navigator.userAgentData?.platform ?? navigator.platform);
  const detectedPlatform = platform ?? browserPlatform ?? '';

  return /mac|iphone|ipad|ipod/i.test(detectedPlatform)
    ? KEYBOARD_SHORTCUT_PLATFORMS.MAC
    : KEYBOARD_SHORTCUT_PLATFORMS.WINDOWS_LINUX;
};
